<div class="window">
  <div id="content" class="content" [ngClass]="{ hidden: sidebarService.hideSidebar }">
    <app-toast [hidden]="sidebarService.hideSidebar"></app-toast>
    <app-toast-v2></app-toast-v2>
    <router-outlet></router-outlet>
    <div style="margin-bottom: 48px"></div>
  </div>
</div>
